const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

const replaceHTMLAttributes = (
  htmlString,
  attributeName,
  replacementString,
) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(
    regex,
    `${attributeName}="${replacementString}"`,
  );

  return modifiedHTML;
};

const removeHTMLAttributes = (htmlString, attributeName) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(regex, "");

  return modifiedHTML;
};

const triggerEvent = (element, name, data = {}) => {
  window.events = window.events || {};
  if (!window.events[name]) {
    window.events[name] = debounce((element, name, data) => {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        }),
      );
    }, 300);
  }
  window.events[name](element, name, data);
};

const delegate = (parent, eventName, childSelector, callback) => {
  if (typeof childSelector === "function") {
    callback = childSelector;
    childSelector = null;
  }
  const selector = childSelector
    ? childSelector
    : "." + [...parent.classList].join(".").replaceAll(":", "\\:");
  parent.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (target) {
      callback(event, target);
    }
  });
};

const summaryAccordion = (event) => {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (reducedMotion.matches) {
    return;
  }

  const summaryElement = event.currentTarget;
  const detailsElement = summaryElement.parentNode;
  const isOpen = detailsElement.hasAttribute("open");
  const accordion = summaryElement.nextElementSibling;

  let animation;

  let options = {
    duration: 0,
    easing: "cubic-bezier(1,0,0,1)",
    fill: "forwards",
  };

  if (isOpen) {
    // close
    event.preventDefault();

    animation?.pause();
    heightStart = accordion.style.height;

    if (animation) {
      const timing = animation.effect.getComputedTiming();
      const activeDuration = timing.activeDuration;
      const activeProgress = timing.progress;

      options.duration -= activeDuration - activeProgress * activeDuration;
    }

    animation?.cancel();

    animation = accordion.animate(
      [{ height: heightStart }, { height: "0px" }],
      options,
    );

    animation.finished.then(() => {
      detailsElement.removeAttribute("open");
      if (detailsElement.parentElement.closest("details[open]")) {
        trapFocus(
          detailsElement.parentElement.closest("details[open]"),
          detailsElement.querySelector("summary"),
        );
      }
      accordion.style.height = "0px";
      summaryElement.style.cursor = "s-resize";
    });
  } else {
    // open
    accordion.classList.remove("hidden"); // remove class as there's js doing the work.

    accordion.style.opacity = 0;
    accordion.style.height = "auto";
    accordion.style.position = "absolute";

    let heightStart;

    setTimeout(() => {
      heightStart = accordion.scrollHeight;
      accordion.style.opacity = 1;
      accordion.style.height = 0;
      accordion.style.position = "";

      animation = accordion.animate(
        [{ height: "0px" }, { height: heightStart }],
        options,
      );

      animation.finished.then(() => {
        accordion.style.height = accordion.scrollHeight + "px";
        summaryElement.style.cursor = "n-resize";
      });
    }, 1);
  }
};

document
  .querySelectorAll('summary[type="accordion"]')
  .forEach((summary) => summary.addEventListener("click", summaryAccordion));

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (e) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("model-viewer")
    .forEach((model) => model.modelViewerUI?.pause());
}

function pauseThisMedia(media) {
  if (media.tagName === "VIDEO") {
    media.pause();
  } else if (media.tagName === "IFRAME") {
    if (media.classList.contains("js-youtube")) {
      media.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
        "*",
      );
    } else if (media.classList.contains("js-vimeo")) {
      media.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else if (media.tagName === "MODEL-VIEWER") {
    media.modelViewerUI?.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class DisclosureElement extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector("button"),
    };
    this.elements.button.addEventListener("click", this.toggle.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.listItems = this.querySelectorAll("li[data-value]");
    this.listItems.forEach((item) =>
      item.addEventListener("click", this.onListItemClick.bind(this)),
    );
  }

  // Cleanup function to remove the event listener when the element is disconnected
  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  onListItemClick(event) {
    const listItem = event.currentTarget;
    const value = listItem.dataset.value;
    this.querySelector(".selected-value").innerText = value;
    this.close();
    this.listItems.forEach((item) => item.classList.remove("font-bold"));
    listItem.classList.add("font-bold");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.close();
    this.elements.button.focus();
  }

  toggle() {
    const isExpanded =
      this.elements.button.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.elements.button.setAttribute("aria-expanded", "true");
    document.addEventListener(
      "click",
      this.handleDocumentClick.bind(this),
      true,
    );
  }

  close() {
    this.elements.button.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    const isOutsideClick = !this.contains(event.target);
    if (isOutsideClick) {
      this.close();
    }
  }
}

customElements.define("disclosure-element", DisclosureElement);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.dropdown-trigger)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement =
      event.target.parentElement.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement =
      detailsElement.parentElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const input = summaryElement.querySelector("input");
    if (input) input.checked = !input.checked;

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 1);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut(e) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.parentElement.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement =
      detailsElement.parentElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 1) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.parentElement.closest("details[open]")) {
          trapFocus(
            detailsElement.parentElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.menuDrawer = this.querySelector("#menu-drawer");
    if (this.menuDrawer) {
      const amount = parseInt(
        window.getComputedStyle(document.querySelector("header-element"))
          .paddingBottom,
      );
      this.querySelector("#menu-drawer").style.marginTop = -amount + "px";
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector("header-element");
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
    // window.scrollTo(0, 0);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    // this.mainDetailsToggle.addEventListener(
    //   "focusout",
    //   this.onFocusOut.bind(this)
    // );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (event.target.classList.contains("_modalClose")) this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  async show(opener) {
    opener.querySelector(".spinner")?.classList.remove("hidden");
    await this.querySelector(".template-popup")?.loadContent();
    await this.querySelector("section-fetcher")?.checkAndFetch();
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("opening", "");
    setTimeout(() => {
      this.setAttribute("open", "");
      this.removeAttribute("opening");
    }, 1);
    trapFocus(this, this.querySelector('[role="dialog"]'));
    opener.querySelector(".spinner")?.classList.add("hidden");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class AnchorNavigation extends HTMLElement {
  constructor() {
    super();
    this.$anchorLinksArray = [...this.querySelectorAll("a")];

    this.$anchoredNodes = this.$anchorLinksArray.map((link) =>
      document.querySelector(link.getAttribute("href")),
    );

    let options = {
      threshold: 0.2,
    };

    let observer = new IntersectionObserver(this.callback.bind(this), options);

    this.$anchoredNodes.forEach((node) => observer.observe(node));
  }

  callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting === true) {
        const intersectingElementId = entry.target.id;

        const intersectingElementLink = this.$anchorLinksArray.find(
          (link) => link.getAttribute("href") === `#${entry.target.id}`,
        );

        this.handleIntersectingElementLink(intersectingElementLink);
      }

      if (entry.boundingClientRect > 0) {
        // scrolling down
      } else {
        // scrolling up
      }
    });
  }

  handleIntersectingElementLink(intersectingElementLink) {
    const deactiveLinks = this.$anchorLinksArray.filter(
      (link) => link !== intersectingElementLink,
    );

    deactiveLinks.forEach((link) => {
      const inactiveClasses = link.dataset.inactiveClass.split(" ");
      const activeClasses = link.dataset.activeClass.split(" ");
      link.classList.add(...inactiveClasses);
      link.classList.remove(...activeClasses);
    });

    const inActiveClasses =
      intersectingElementLink.dataset.inactiveClass.split(" ");
    const activeClasses =
      intersectingElementLink.dataset.activeClass.split(" ");
    intersectingElementLink.classList.add(...activeClasses);
    intersectingElementLink.classList.remove(...inActiveClasses);
  }
}

customElements.define("anchor-navigation", AnchorNavigation);

function zoom(e) {
  var zoomer = e.currentTarget.querySelector("img");
  e.offsetX
    ? (offsetX = e.offsetX)
    : (offsetX = e.originalEvent.touches[0].pageX);
  e.offsetY
    ? (offsetY = e.offsetY)
    : (offsetX = e.originalEvent.touches[0].pageX);
  x = (offsetX / zoomer.offsetWidth) * 20;
  y = (offsetY / zoomer.offsetHeight) * 20;
  zoomer.style.transform = "translate(-" + x + "%, -" + y + "%)";
}

const fetchJSONMini = async (url, tagName = "json-api") => {
  return fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const el = doc.getElementsByTagName(tagName)[0];
      return JSON.parse(el.innerHTML);
    });
};

const fetchElement = async (url, tagName, targetNode) => {
  return fetch(url)
    .then((response) => response.text())
    .then((html) => {
      if (targetNode) {
        html = html.replaceAll(
          "api--product-card",
          targetNode.dataset.sectionId,
        );
      }
      let doc = new DOMParser().parseFromString(html, "text/html");
      if (doc.getElementsByTagName(tagName)[0]) {
        return doc.getElementsByTagName(tagName)[0];
      }
    })
    .catch(status, (err) => {
      console.error(err);
    });
};

function lockScrollForThis(element) {
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
  element.dataset.scrollY = scrollY;
}

function unlockScrollForThis(element) {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo({
    behavior: "instant",
    left: 0,
    top: parseInt(element.dataset.scrollY || "0"),
  });
}

function preventDefault(e) {
  e.preventDefault();
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (!customElements.get("accordion-element")) {
  class AccordionElement extends HTMLElement {
    constructor() {
      super();
      this.isOpen = this.classList.contains("active");
    }

    connectedCallback() {
      this.$title = this.querySelector("accordion-title");
      this.$content = this.querySelector("accordion-content");
      this.style.transition = "";
      this.height = this.$content.scrollHeight;
      this.style.transition = "0.3s max-height";
      this.events();
      this.isOpen && this.open();
    }

    events() {
      this.$title.addEventListener("click", this.handleClick.bind(this));
      this.$title.addEventListener("keydown", (event) => {
        switch (event.key) {
          case "ArrowDown":
            this.handleClick();
            break;
          case "ArrowUp":
            this.close();
            break;
          case "ArrowLeft":
            this.close();
            break;
          case "ArrowRight":
            this.handleClick();
            break;
          case "Enter":
            this.handleClick();
            break;
          case "Space":
            this.handleClick();
            break;
        }
      });
      this.$title.setAttribute("tabindex", "0");
    }

    handleClick() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    close() {
      this.isOpen = false;
      this.classList.remove("active");
      this.$content.style.maxHeight = `${this.height}px`;
      this.$content.setAttribute("aria-hidden", true);
      this.$content.addEventListener(
        "transitionend",
        this.handleTransition.bind(this),
        { once: true },
      );

      setTimeout(() => {
        this.$content.style.maxHeight = `${0}px`;
      }, 1);
    }

    open() {
      this.isOpen = true;
      this.$content.classList.remove("hidden");
      this.height = this.$content.scrollHeight;
      setTimeout(() => {
        this.classList.add("active");
        this.$content.classList.remove("is-invisible");
        this.$content.style.maxHeight = `${0}px`;
        this.$content.removeAttribute("aria-hidden");
        this.$content.addEventListener(
          "transitionend",
          this.handleTransition.bind(this),
          { once: true },
        );

        setTimeout(() => {
          this.$content.style.maxHeight = `${this.height}px`;
        }, 2);
      }, 1);
    }

    handleTransition() {
      if (!this.isOpen) {
        this.$content.classList.add("is-invisible");
        setTimeout(() => {
          this.$content.classList.add("hidden");
        }, 5000);
      }

      this.$content.style.maxHeight = "";
    }
  }
  customElements.define("accordion-element", AccordionElement);
}
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

if (!customElements.get("quantity-input")) {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      this.changeEvent = new Event("change", { bubbles: true });
      this.form = this.querySelector("form");
      this.quantityDisplay = this.querySelector("[data-quantity-display]");

      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this)),
      );
      this.input.addEventListener("change", this.onInputChange.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      this.previousValue = this.input?.value;

      event.currentTarget.ariaLabel === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();

      if (this.dataset.mode == "qty") return;

      if (this.previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
      this.querySelector(".hide-when-spinner")?.classList.add("opacity-0");
      this.querySelector(".spinner").classList.remove("hidden");

      document.querySelectorAll(".cart-spinner").forEach((spinner) => {
        spinner.classList.remove("hidden");
      });
    }

    onInputChange(event) {
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);

      this.dynamicSectionsNodes = document.querySelectorAll("cart-dynamic");

      let dynamicSections = [];
      if (this.dynamicSectionsNodes) {
        dynamicSections = [...this.dynamicSectionsNodes].map(
          (item) => item.dataset.sectionId,
        );
      }

      formData.append("sections", dynamicSections.join(","));
      config.body = formData;

      let url =
        this.dataset.quantity == 0
          ? routes.cart_add_url
          : routes.cart_change_url;

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 422) {
            this.input.value = this.previousValue;
            this.handleErrorMessage(response.message);
          }
          if (
            response.item_count === 0 &&
            window.location.pathname === "/cart"
          ) {
            window.location.reload();
          }

          this.response = response;

          let cartItem =
            this.dataset.quantity == 0
              ? response
              : response.items.find(
                  (item) => item.variant_id == this.dataset.id,
                );

          this.dataset.quantity = cartItem ? cartItem.quantity : 0;
          this.quantityDisplay.innerText = this.dataset.quantity;

          this.updateClones();

          // update dynamic sections
          this.dynamicSectionsNodes.forEach((node) => {
            const htmlString = this.response.sections[node.dataset.sectionId];
            const html = new DOMParser().parseFromString(
              htmlString,
              "text/html",
            );
            node.animate([{ opacity: 0 }, { opacity: 1 }], {
              duration: 150,
              easing: "ease-in-out",
              fill: "forwards",
            });
            node.innerHTML = html.querySelector(
              `cart-dynamic[data-section-id='${node.dataset.sectionId}']`,
            ).innerHTML;
            node.classList = html.querySelector(
              `cart-dynamic[data-section-id='${node.dataset.sectionId}']`,
            ).classList;
            node.animate([{ opacity: 0 }, { opacity: 1 }], {
              duration: 150,
              easing: "ease-in-out",
              fill: "forwards",
            });
            node.modified();
          });

          // if the cart is updated, trigger the event
          // add the tag name of this
          triggerEvent(document, "cart:update", {
            source: this.tagName.toLowerCase(),
            found: response.item_count > 0,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector(".spinner").classList.add("hidden");
          this.querySelector(".hide-when-spinner")?.classList.remove(
            "opacity-0",
          );
          document.querySelectorAll(".cart-spinner").forEach((spinner) => {
            spinner.classList.add("hidden");
          });
        });
    }

    updateClones() {
      const clones = document.querySelectorAll(
        `quantity-input[data-id="${this.dataset.id}"]:not([data-mode="qty"])`,
      );

      for (const clone of clones) {
        if (clone == this) continue;
        if (clone.dataset.linkMode == "true") continue;

        clone.dataset.quantity = this.dataset.quantity;
        clone.quantityDisplay.innerText = this.dataset.quantity;
        clone.input.value = this.dataset.quantity;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrappers =
        this.errorMessageWrappers || this.querySelectorAll("error-message");

      this.errorMessageWrappers.forEach((errorMessageWrapper) => {
        if (errorMessage) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = errorMessage;
          errorMessageWrapper.classList.remove("hidden");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
          }, 3000);
        } else {
          errorMessageWrapper.classList.add("hidden");
        }
      });
      throw new Error(errorMessage);
    }
  }
  customElements.define("quantity-input", QuantityInput);
}

class SectionFetcher extends HTMLElement {
  static observedAttributes = [
    "data-url",
    "data-section-id",
    "data-selector",
    "data-animate",
    "data-fire-event",
    "data-onload",
    "data-load-on-event",
  ];

  constructor() {
    super();
    this.handlePopState = this.handlePopState.bind(this);
    this.debouncedCheckAndFetch = this.debounce(
      this.checkAndFetch.bind(this),
      250,
    );
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.setupInitialState();
    this.addEventListeners();
    this.reWriteData();
    if (this.dataset.onload === "true") {
      this.setupIntersectionObserver();
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
    this.removeIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      rootMargin: "0px 0px 800px 0px",
      threshold: 0,
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.dataset.onload === "true") {
          queueMicrotask(() => this.checkAndFetch(true));
          this.removeIntersectionObserver();
        }
      });
    }, options);

    this.intersectionObserver.observe(this);
  }

  removeIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || name !== "data-url") return;
    this.debouncedCheckAndFetch(false, true);
  }

  setupInitialState() {
    const defaultUrl = new URL(window.location.href);
    defaultUrl.searchParams.delete("section_id");
    this.dataset.url = this.dataset.url || defaultUrl.toString();
    this.lastFetchedUrl = this.dataset.url || window.location.href;

    // add feed heights for pagination
    if (this.querySelector("pagination-element")) {
      // reset saved heights for pagination
      window.addEventListener("resize", () => (window.feedHeights = {}));
      this.saveFeedTemporarily();
      this.fixHeight();
      const resetHeight = () => {
        if (this.style.height === "") return;
        setTimeout(() => {
          this.style.height = window.feedHeights[this.dataset.url] + "px";
          setTimeout(() => {
            this.style.height = "";
          }, 800);
        }, 300);
      };

      this.addEventListener("mouseleave", resetHeight);
      if ('ontouchstart' in window) {
        window.addEventListener("scroll", resetHeight, { passive: true });
      }
    }
  }

  addEventListeners() {
    if (!this.disablePopEvents) {
      window.addEventListener("popstate", this.handlePopState, {
        passive: true,
      });
    }
    if (this.dataset.loadOnEvent) {
      window.addEventListener(this.dataset.loadOnEvent, this.handlePopState, {
        passive: true,
      });
    }
  }

  removeEventListeners() {
    window.removeEventListener("popstate", this.handlePopState);
    if (this.dataset.loadOnEvent) {
      window.removeEventListener(this.dataset.loadOnEvent, this.handlePopState);
    }
  }

  handlePopState() {
    this.dataset.url = this.buildFetchUrl(window.location.href);
    this.debouncedCheckAndFetch(false);
  }

  async checkAndFetch(isInitialLoad = true, isAttributeChange) {
    const currentUrl = new URL(this.dataset.url, window.location.origin);
    const dataUrl = new URL(this.lastFetchedUrl, window.location.origin);

    const relevantParams = new Set([
      "sort_by",
      "page",
      "q",
      ...Array.from(dataUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
      ...Array.from(currentUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
    ]);

    let shouldFetch = isInitialLoad;

    for (const param of relevantParams) {
      const currentValues = currentUrl.searchParams.getAll(param);
      const dataValues = dataUrl.searchParams.getAll(param);

      if (param === "page" && currentValues[0] == 1 && dataValues.length === 0)
        return;

      if (JSON.stringify(currentValues) !== JSON.stringify(dataValues)) {
        shouldFetch = true;
        dataUrl.searchParams.delete(param); // Remove all existing values for this param
        currentValues.forEach((value) => {
          dataUrl.searchParams.append(param, value); // Add each value individually
        });
      }
    }

    if (shouldFetch) {
      const newUrl = dataUrl.toString();
      const fetchUrl = this.buildFetchUrl(newUrl);

      if (fetchUrl !== this.lastFetchedUrl) {
        this.lastFetchedUrl = fetchUrl;
        await this.fetchAndReplaceContent(fetchUrl, isAttributeChange);
        return true;
      }
    }
  }

  buildFetchUrl(url) {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", this.dataset.sectionId);
    return fetchUrl.toString();
  }

  async showSkeletons() {
    this.skeletonWrappers = this.querySelectorAll("[data-skeleton-wrapper]");
    if (this.skeletonWrappers.length > 0) {
      this.skeletonWrappers.forEach(async (wrapper) => {
        await wrapper.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 150,
          easing: "ease-in-out",
        }).finished;
        wrapper.innerHTML = "";
        if (wrapper.dataset.multipleSkeletons) {
          const skeletonItems = parseInt(this.dataset.skeletonItems);
          // add the skeleton element skeletonItems time
          for (let i = 0; i < skeletonItems; i++) {
            wrapper.innerHTML +=
              window.skeletons[wrapper.dataset.skeletonWrapper];
          }
        } else {
          wrapper.innerHTML = window.skeletons[wrapper.dataset.skeletonWrapper];
        }
        return;
      });
    } else {
      return;
    }
  }

  async hideSkeletons() {
    if (this.skeletonWrappers?.length > 0) {
      this.skeletonWrappers.forEach(async (wrapper) => {
        wrapper.style.opacity = 1;
        // await wrapper.animate([{ opacity: 0 }, { opacity: 1 }], {
        //   duration: 150,
        //   easing: "ease-in-out",
        // }).finished;
      });
    }
  }

  fixHeight() {
    // skip if touch device
    // if ("ontouchstart" in window) return;
    // define defaults
    window.feedHeights = window.feedHeights || {};
    window.feedHeights[this.id] = window.feedHeights[this.id] || [];
    window.feedHeights[this.dataset.url] =
      window.feedHeights[this.dataset.url] || [];
    // save height
    window.feedHeights[this.id].push(this.offsetHeight);
    window.feedHeights[this.dataset.url] = this.offsetHeight;
    // unique values
    window.feedHeights[this.id] = [...new Set(window.feedHeights[this.id])];
    // from big to small
    window.feedHeights[this.id].sort((a, b) => b - a);
    // set height
    if (window.feedHeights[this.id][0] === 0) return;
    this.style.height = window.feedHeights[this.id][0] + "px";
  }

  saveFeedTemporarily(url = this.buildFetchUrl(this.dataset.url)) {
    window.temporaryFeeds = window.temporaryFeeds || {};
    Object.keys(window.temporaryFeeds).forEach((key) => {
      if (key !== this.id) {
        delete window.temporaryFeeds[key];
      }
    });
    window.temporaryFeeds[this.id] = window.temporaryFeeds[this.id] || {};
    window.temporaryFeeds[this.id][url] = this.outerHTML;
  }

  clearTemporaryFeed() {
    setTimeout(() => (window.temporaryFeeds = {}), 1000);
  }

  keepData() {
    if (!this.dataset.toKeep) return;
    window.temporaryDatas = window.temporaryDatas || {};
    window.temporaryDatas[this.id] = {};
    this.dataset.toKeep.split(",").forEach((data) => {
      window.temporaryDatas[this.id][data] = this.dataset[data];
    });
    setTimeout(() => (window.temporaryDatas = {}), 3000);
  }

  reWriteData() {
    if (!window.temporaryDatas || !window.temporaryDatas[this.id]) return;
    Object.entries(window.temporaryDatas[this.id]).forEach(([key, value]) => {
      this.dataset[key] = value;
    });
  }

  async fetchAndReplaceContent(url, isAttributeChange) {
    try {
      this.keepData();
      let newContent;
      if (
        window.temporaryFeeds &&
        window.temporaryFeeds[this.id] &&
        window.temporaryFeeds[this.id][this.dataset.url]
      ) {
        newContent = this.parseHTML(
          window.temporaryFeeds[this.id][this.dataset.url],
        );
        this.dataset.animate = "false";
      }

      if (!newContent) {
        if (isAttributeChange) {
          this.fixHeight();
        }
        if (this.dataset.animate !== "false") {
          await this.showSkeletons();
        }
        if (isAttributeChange) {
          this.fixHeight();
        }
        const response = await this.fetchWithRetry(url);
        const html = await response.text();
        newContent = this.parseHTML(html);
        if (newContent === null) {
          this.remove();
          return;
        }
      }

      if (this.dataset.animate !== "false") {
        await this.animateTransition(newContent);
      } else {
        this.replaceWith(newContent);
      }

      this.fireCustomEvent(newContent);
      if (this.dataset.animate !== "false") {
        await this.hideSkeletons();
      }
      return true;
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  }

  async fetchWithRetry(url, retries = 3) {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        return response;
      } catch (error) {
        if (i === retries - 1) throw error;
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * Math.pow(2, i)),
        );
      }
    }
  }

  parseHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (
      doc.querySelector(`[data-section-id="${this.dataset.sectionId}"]`) ??
      doc.querySelector(`[data-section="${this.dataset.sectionId}"]`)
    );
  }

  async animateTransition(newContent) {
    await this.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 100,
    }).finished;

    this.replaceWith(newContent);

    this.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 100,
    });
  }

  replaceContent(newContent) {
    replaceNodeWithNodeList(this, newContent);
  }

  fireCustomEvent(newContent) {
    if (this.dataset.fireEvent) {
      const event = new CustomEvent(this.dataset.fireEvent, {
        bubbles: true,
        detail: {
          source: this.dataset.id,
          found: newContent.length > 0,
        },
      });
      this.dispatchEvent(event);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define("section-fetcher", SectionFetcher);

if (!customElements.get("cart-dynamic")) {
  customElements.define(
    "cart-dynamic",
    class CartDynamic extends SectionFetcher {
      constructor() {
        super();
        this.disablePopEvents = true;
      }

      connectedCallback() {
        super.connectedCallback();
        document.addEventListener("cart:update", (e) => {
          if (e.detail.source !== "quantity-input") {
            this.fetchAndReplaceContent();
          }
        });
      }

      modified(miliseconds = 1000) {
        this.dataset.modified = true;

        setTimeout(() => {
          this.removeAttribute("data-modified");
        }, miliseconds);
      }
    },
  );
}

const updateSearchParams = (searchParams, keepKeys) => {
  // summarize what this function does
  // it takes the current url and updates the search params with the new search params
  const urlParams = new URLSearchParams(window.location.search);
  const activeParams = [];
  const newParams = searchParams.split("&");
  if (keepKeys) {
    urlParams.forEach((value, key) => {
      if (keepKeys.includes(key)) {
        newParams.push(`${key}=${value}`);
      }
    });
  }

  const baseUrl = window.location.href.split("?")[0];
  return `${baseUrl}?${newParams.join("&")}`;
};

class TabComponent extends HTMLElement {
  // use as
  //         <tab-component data-tab-wrapper-styles-add="flex justify-center">
  //          <div label="tab1">content</div>
  //         <div label="tab2" style="display:none;" >content</div>

  constructor() {
    super();

    this.tabWrapperStyles =
      this.dataset.tabWrapperStyles ||
      `mx-2 md:mx-0 inline-flex overflow-hidden border border-text/50 rounded flex-wrap ${this.dataset.tabWrapperStylesAdd}`;
    this.tabStyles =
      this.dataset.tabStyles ||
      `px-3 py-2 cursor-pointer ${this.dataset.tabStylesAdd}`;
    this.deactiveTabStyles =
      this.dataset.deactiveTabStyles ||
      `hover:bg-background1 first:border-l-0 last:border-r-0 border-x border-text/50 bg-background2 ${this.dataset.deactiveTabStylesAdd}`;
    this.activeTabStyles =
      this.dataset.activeTabStyles ||
      `bg-accent1 text-accent1_fg first:border-l-0 last:border-r-0 border-x border-accent1 cursor-default shadow ${this.dataset.activeTabStylesAdd}`;
    this.contentStyles = this.dataset.contentStyles || "py-5";
  }

  connectedCallback() {
    this.render();
    this.selectTab(0);
  }

  render() {
    this.innerHTML = `
    <div>
      <div class="tab-list ${this.tabWrapperStyles}" role="tablist">
        ${this.createTabs()}
      </div>
      <div class="tab-content ${this.contentStyles}">
        ${this.createContent()}
      </div>
    </div>
    `;

    this.registerClickEvent();
  }

  createTabs() {
    return [...this.children]
      .map((child, index) => {
        return `<button class="tab-list-item ${this.tabStyles} ${
          index === 0 ? this.activeTabStyles : this.deactiveTabStyles
        }" data-index="${index}" role="tab" tabindex="${
          index === 0 ? "0" : "-1"
        }" aria-selected="${
          index === 0 ? "true" : "false"
        }">${child.getAttribute("label")}</button>`;
      })
      .join("");
  }

  createContent() {
    return [...this.children]
      .map((child, index) => {
        return `<div class="tab-content-item" data-index="${index}" role="tabpanel" tabindex="0" style="display: none;">${child.innerHTML}</div>`;
      })
      .join("");
  }

  registerClickEvent() {
    this.querySelectorAll(".tab-list-item").forEach((tab, index) => {
      tab.addEventListener("click", () => this.selectTab(index));
    });
  }

  selectTab(index) {
    let activeTabClasses = this.activeTabStyles.split(" ");
    let deactiveTabClasses = this.deactiveTabStyles.split(" ");

    this.querySelectorAll(".tab-list-item").forEach((tab, i) => {
      tab.classList.add(...deactiveTabClasses);
      tab.classList.remove(...activeTabClasses);
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });

    this.querySelectorAll(".tab-list-item")[index].classList.add(
      ...activeTabClasses,
    );
    this.querySelectorAll(".tab-list-item")[index].classList.remove(
      ...deactiveTabClasses,
    );
    this.querySelectorAll(".tab-list-item")[index].setAttribute(
      "aria-selected",
      "true",
    );
    this.querySelectorAll(".tab-list-item")[index].setAttribute(
      "tabindex",
      "0",
    );

    this.querySelectorAll(".tab-content-item").forEach((child, i) => {
      child.style.display = "none";
      child.setAttribute("aria-hidden", "true");
    });

    this.querySelectorAll(".tab-content-item")[index].style.display = "block";
    this.querySelectorAll(".tab-content-item")[index].setAttribute(
      "aria-hidden",
      "false",
    );
  }
}

window.customElements.define("tab-component", TabComponent);

function handleImageError(imgElement) {
  imgElement.classList.add("hidden");
  const fallback = imgElement.parentElement.querySelector(".fallback");
  fallback.classList.remove("hidden");
}

customElements.define(
  "eye-in-the-sky",
  class EyeInTheSky extends HTMLElement {
    constructor() {
      super();
      this.password = document.getElementById(this.dataset.target);
    }

    connectedCallback() {
      this.addEventListener("click", () => this.handleClick());
    }

    handleClick() {
      this.classList.toggle("active");
      const isPassword = this.password.type === "password";
      this.password.type = isPassword ? "text" : "password";
    }
  },
);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300),
    );
  }
}

customElements.define("cart-note", CartNote);
if (!customElements.get("slider-component")) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("ul");
      this.sliderItems = this.querySelectorAll(".slider-items");
      this.sliderThumbnails = this.querySelectorAll("slider-thumbnails li");
      this.pageCount = this.querySelector(".slider-counter--current");
      this.pageTotal = this.querySelector(".slider-counter--total");
      this.prevButton = this.querySelector('button[aria-label="previous"]');
      this.nextButton = this.querySelector('button[aria-label="next"]');

      this.initThumbnails();

      this.lightbox = this.querySelector(".lightbox");
      if (this.lightbox) this.initLightbox();

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener("scroll", this.update.bind(this));
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

      this.initVideoListeners();
    }

    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(
        this.slider.clientWidth / this.sliderItems[0].clientWidth,
      );
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }

    initThumbnails() {
      this.sliderThumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          this.slideTo(index);
        });
      });
    }

    initVideoListeners() {
      const videoElements = this.querySelectorAll(
        "video, .js-youtube, .js-vimeo",
      );
      videoElements.forEach((video) => {
        // is video intersecting
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              pauseThisMedia(video);
            } else {
              if (video.tagName === "VIDEO" && video.autoplay) video.play();
            }
          });
        });
        observer.observe(video);
      });
    }

    update() {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) +
        1;

      const img = this.sliderItems[this.currentPage]?.querySelector("img");
      if (img && !img.complete) {
        const image = new Image();
        image.src = img.src;
        if (img.srcset) image.srcset = img.srcset;
      }

      if (this.currentPage === 1) {
        this.prevButton.setAttribute("disabled", true);
      } else {
        this.prevButton.removeAttribute("disabled");
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute("disabled", true);
      } else {
        this.nextButton.removeAttribute("disabled");
      }

      if (!this.pageCount || !this.pageTotal) return;
      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    slideTo(index) {
      this.slider.scrollTo({
        left: this.sliderItems[0].clientWidth * index,
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
          : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }

    initLightbox() {
      this.lightboxSlider = this.lightbox.querySelector("slider-component ul");
      this.sliderItems.forEach((item, index) => {
        const trigger = item.classList.contains("js-lightbox")
          ? item
          : item.querySelector(".js-lightbox");
        trigger?.addEventListener("click", () => {
          this.lightbox.querySelector("fader-component").activate(index);
          this.lightbox.classList.replace("hidden", "fixed");
          // record the scroll position
          this.scrollPosition = window.scrollY;
          document.body.classList.add("fixed");
        });
      });

      this.slider.addEventListener("scroll", (e) => {
        this.lightboxSlider.scrollLeft =
          (this.slider.scrollLeft / this.slider.scrollWidth) *
          this.lightboxSlider.scrollWidth;
      });

      this.lightboxCloser = this.lightbox.querySelector("#close-lightbox");

      this.lightboxCloser.addEventListener("click", () => {
        document.body.classList.remove("fixed");
        pauseAllMedia();
        this.lightbox.classList.replace("fixed", "hidden");
        // instant scroll
        window.scrollTo({
          top: this.scrollPosition,
          behavior: "instant",
        });
      });
    }
  }

  customElements.define("slider-component", SliderComponent);
}

if (!customElements.get("fader-component")) {
  class FaderComponent extends HTMLElement {
    constructor() {
      super();
      this.sliderItems = this.querySelectorAll(".fader-item");
      this.sliderThumbnails = this.querySelectorAll(`fader-thumbnails li`);
      this.initThumbnails();
    }

    initThumbnails() {
      this.sliderThumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          this.activate(index);
        });
      });
    }

    activate(index) {
      this.querySelectorAll(".fader-item img").forEach((img) => {
        if (img.complete) return;
        const image = new Image();
        image.src = img.src;
        if (img.srcset) image.srcset = img.srcset;
      });
      this.sliderItems.forEach((item) => item.classList.add("hidden"));
      this.sliderItems[index].classList.remove("hidden");
    }
  }

  customElements.define("fader-component", FaderComponent);
}
if (!customElements.get("snap-slider")) {
  class SnapSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector("feed");
      this.previousButton = document.querySelector(
        `button[aria-label="previous"][data-slider-target="${this.dataset.id}"]`,
      );
      this.nextButton = document.querySelector(
        `button[aria-label="next"][data-slider-target="${this.dataset.id}"]`,
      );
      this.gradientFinish = this.querySelector("gradient-finish");

      if (this.dataset.dummy === "true") {
        const mutationOptions = {
          childList: true,
        };
        this.sliderObserver = new MutationObserver(this.initSlider.bind(this));
        this.sliderObserver.observe(this.slider, mutationOptions);
      }

      this.sliderIntersectionObserver = new IntersectionObserver(
        this.initSliderIfIntersecting.bind(this),
      );
      this.sliderIntersectionObserver.observe(this.slider);

      this.sliderBar = document.querySelector(
        `[data-slider-target="${this.dataset.id}"].js-slider-bar`,
      );

      if (this.previousButton) {
        this.previousWrapper =
          this.previousButton.parentElement === this
            ? this.previousButton
            : this.previousButton.parentElement;
      }
    }

    initSliderIfIntersecting(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
          this.initSlider();
          this.sliderIntersectionObserver.unobserve(this.slider);
        }
      });
    }

    initSlider() {
      if (!this.slider.clientWidth > 0) return;
      const firstMeaningfulItem = this.querySelector("feed > *");
      if (!firstMeaningfulItem) return;
      this.sliderItems = firstMeaningfulItem.classList.contains("contents")
        ? this.querySelectorAll("feed .contents > *")
        : this.querySelectorAll("feed > *");

      if (!this.sliderItems) return;

      if (!this.sliderItems.length === 0) return;

      if (this.gradientFinish) {
        let setHeight =
          this.slider.children[0].clientHeight != 0
            ? this.slider.children[0].clientHeight
            : [...this.slider.children[0].children].find(
                (child) => child.clientHeight > 0,
              )?.clientHeight;
        this.gradientFinish.style.height = `${setHeight}px`;
        this.gradientFinish.style.top = `${
          (this.slider.clientHeight - setHeight) / 2
        }px`;
      }

      this.previousButton?.addEventListener(
        "click",
        this.onButtonClick.bind(this),
      );
      this.nextButton?.addEventListener("click", this.onButtonClick.bind(this));

      this.firstEl = [...this.sliderItems].find((item) => item.clientWidth > 0);

      if (!this.firstEl) return;

      this.lastEl = [...this.sliderItems]
        .reverse()
        .find((item) => item.clientWidth > 0);
 // Create a loop clone for smooth wrap (only if explicitly enabled)
      if (
        this.dataset.loopClone === "true" &&
        !this._loopCloned &&
        this.firstEl &&
        this.slider
      ) {
        const loopContainer =
          this.querySelector("feed > .contents") || this.slider;
        try {
          const clone = this.firstEl.cloneNode(true);
          clone.setAttribute("data-clone", "true");
          loopContainer.appendChild(clone);
          this._loopCloned = true;
          // Recalculate items and last element after cloning
          const firstMeaningfulItemAfterClone = this.querySelector("feed > *");
          this.sliderItems = firstMeaningfulItemAfterClone.classList.contains(
            "contents",
          )
            ? this.querySelectorAll("feed .contents > *")
            : this.querySelectorAll("feed > *");
          this.lastEl = [...this.sliderItems]
            .reverse()
            .find((item) => item.clientWidth > 0);
        } catch (e) {
          // ignore cloning errors silently
        }
      }

      if (this.isScrolledToStart) {
        this.isScrolledToStart.disconnect();
        this.isScrolledToEnd.disconnect();
      }
      let options = { threshold: 1, root: this.slider };
      this.isScrolledToStart = new IntersectionObserver(
        this.togglePrevious.bind(this),
        options,
      );
      this.isScrolledToEnd = new IntersectionObserver(
        this.toggleNext.bind(this),
        options,
      );

      this.sliderElementIntersection = new IntersectionObserver(
        this.toggleObservers.bind(this),
        { threshold: 1 },
      );
      this.sliderElementIntersection.observe(this.slider);

      this.slider.addEventListener("scroll", this.onScroll.bind(this));

      // hide slider nav if slider is not scrollable
      const sliderNav = this.querySelector(".js-slider-nav");
      if (sliderNav) {
        const observer = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (entry.target === this.slider) {
              if (this.slider.scrollWidth <= this.slider.clientWidth) {
                sliderNav.classList.add("hidden");
              }
            }
          }
        });
        observer.observe(this.slider);
      }
      
      // initialize autoplay when available
      this.setupAutoplay && this.setupAutoplay();
    }

    onScroll(event) {
      if (this.sliderBar) {
        if (!this.barThreshold) {
          this.barThreshold = this.sliderBar.style.transform
            .split("(")[1]
            .split(")")[0];
        }

        let scale =
          event.target.scrollLeft /
          (event.target.scrollWidth - event.target.clientWidth);
        if (scale < this.barThreshold) {
          scale = this.barThreshold;
        }

        this.sliderBar.style.transform = `scaleX(${scale})`;
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      const firstMeaningfulItem = [...this.sliderItems].find(
        (item) => item.clientWidth > 0,
      );
      const sliderStep =
        this.dataset.sliderStepBy === "page"
          ? this.clientWidth
          : firstMeaningfulItem.clientWidth;
      const slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + sliderStep
          : this.slider.scrollLeft - sliderStep;
      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "smooth",
      });
    }

    toggleObservers(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
          this.isScrolledToStart.observe(this.firstEl);
          this.isScrolledToEnd.observe(this.lastEl);
        } else {
          this.isScrolledToStart.unobserve(this.firstEl);
          this.isScrolledToEnd.unobserve(this.lastEl);
        }
      });
    }

    togglePrevious(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
          this.previousButton?.setAttribute("disabled", "true");
          if (this.nextButton?.hasAttribute("disabled")) {
            this.previousWrapper?.classList.add("opacity-0");
            this.sliderBar?.parentElement.classList.add("opacity-0");
          } else {
            this.previousWrapper?.classList.remove("opacity-0");
            this.sliderBar?.parentElement.classList.remove("opacity-0");
          }
        } else {
          this.previousButton?.removeAttribute("disabled");
          this.previousWrapper?.classList.remove("opacity-0");
          this.sliderBar?.parentElement.classList.remove("opacity-0");
        }
      });
    }

    toggleNext(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
          this.nextButton?.setAttribute("disabled", "true");
          if (this.previousButton?.hasAttribute("disabled")) {
            this.previousWrapper?.classList.add("opacity-0");
            this.sliderBar?.parentElement.classList.add("opacity-0");
          } else {
            this.previousWrapper?.classList.remove("opacity-0");
            this.sliderBar?.parentElement.classList.remove("opacity-0");
          }
        } else {
          this.nextButton?.removeAttribute("disabled");
          this.previousWrapper?.classList.remove("opacity-0");
          this.sliderBar?.parentElement.classList.remove("opacity-0");
        }
      });
    }
    
    // Autoplay helpers
    setupAutoplay() {
      if (this._autoplaySetup) return;
      if (this.dataset.autoplay !== "true") return;
      // do not enable when slider does not overflow
      if (!this.slider || this.slider.scrollWidth <= this.slider.clientWidth) {
        return;
      }
      this._autoplaySetup = true;
      this.autoplayIntervalMs =
        Number(this.dataset.autoplayInterval || 5) * 1000;
      this.startAutoplay();

      // pause on hover/focus and when document hidden
      this.addEventListener("mouseenter", this.stopAutoplay.bind(this));
      this.addEventListener("mouseleave", this.startAutoplay.bind(this));
      this.addEventListener("focusin", this.stopAutoplay.bind(this));
      this.addEventListener("focusout", this.startAutoplay.bind(this));
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });
    }

    startAutoplay() {
      if (!this._autoplaySetup) return;
      if (this._autoplayTimer) return;
      this._autoplayTimer = setInterval(
        this.scrollNext.bind(this),
        this.autoplayIntervalMs,
      );
    }

    stopAutoplay() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    scrollNext() {
      if (!this.slider) return;
      const firstMeaningfulItem = [...this.sliderItems].find(
        (item) => item.clientWidth > 0,
      );
      if (!firstMeaningfulItem) return;
      const sliderStep =
        this.dataset.sliderStepBy === "page"
          ? this.clientWidth
          : firstMeaningfulItem.clientWidth;
      // if at or past end, go to start
      const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
      const epsilon = 8; // tolerate sub-pixel rounding on mobile
      const atEnd = this.slider.scrollLeft >= maxScrollLeft - epsilon;
      if (atEnd) {
        // crossfade to the first slide for a smoother wrap without clones
        const duration = 220;
        const feed = this.slider;
        // fade out
        try {
          feed.animate([{ opacity: 1 }, { opacity: 0 }], {
            duration,
            easing: "ease",
            fill: "forwards",
          });
        } catch (e) {
          feed.style.opacity = "0";
        }
        setTimeout(() => {
          const prevBehavior = feed.style.scrollBehavior;
          feed.style.scrollBehavior = "auto";
          feed.scrollLeft = 0;
          feed.style.scrollBehavior = prevBehavior || "";
          // fade in
          try {
            feed.animate([{ opacity: 0 }, { opacity: 1 }], {
              duration,
              easing: "ease",
              fill: "forwards",
            });
          } catch (e) {
            feed.style.opacity = "1";
          }
        }, duration);
        return;
      } else {
        const left = this.slider.scrollLeft + sliderStep;
        this.slider.scrollTo({ left, behavior: "smooth" });
      }
    }
  }

  customElements.define("snap-slider", SnapSlider);
}
if (!customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector("template");
      this.button = this.querySelector("._playButton");
      this.loaders();
      this.setIframeAspectRatio();
    }

    loaders() {
      if (!this.template) return;
      if (this.button) {
        this.button.addEventListener("click", this.load.bind(this));
        return;
      }
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.load();
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0, rootMargin: "400px" },
      );
      observer.observe(this);
    }

    load() {
      if (this.button) {
        this.style.height = this.getBoundingClientRect().height + "px";
        this.style.width = this.getBoundingClientRect().width + "px";
        this.stopAllVideos();
      }
      this.appendChild(this.template.content.cloneNode(true));
      this.button?.classList.add("hidden");

      setTimeout(() => {
        this.style.height = "";
        this.style.width = "";
      }, 1000);
    }

    stopAllVideos() {
      const videos = document.querySelectorAll("video");
      videos.forEach((video) => {
        if (video !== this.querySelector("video") && !video.autoplay) {
          video.pause();
        }
      });

      const iframes = document.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        if (iframe !== this.querySelector("iframe")) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: "command", func: "pauseVideo" }),
            "*",
          );
        }
      });
    }
    async setIframeAspectRatio() {
      if (!this.template) return;
      const iframe = this.template.content.querySelector("iframe");
      if (!iframe) return;
      if (iframe.src.includes("youtube")) return;
      const { width, height } = await this.getIframeWidthHeight(iframe);
      iframe.style.aspectRatio = `${width}/${height}`;
      if (this.querySelector("iframe")) {
        this.querySelector("iframe").style.aspectRatio = `${width}/${height}`;
        this.style.setProperty("--aspect-ratio", `${width} / ${height}`);
      }
    }
    async getIframeWidthHeight(iframe) {
      let url = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${iframe.dataset.videoId}`;
      const { width, height } = await fetch(url).then((resp) => resp.json());
      return { width, height };
    }
  }
  customElements.define("video-player", VideoPlayer);
}
if (!customElements.get("pagination-element")) {
  class PaginationElement extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute("data-section-fetcher-target")) return;
      this.sectionFetcherTarget = document.getElementById(
        this.dataset.sectionFetcherTarget,
      );
      this.querySelectorAll("a").forEach((link) => {
        // create new href from a href with sectionFetcherTarget's data-section-id value as a parameter to query key section_id
        const newHref = new URL(link.href);
        newHref.searchParams.set(
          "section_id",
          this.sectionFetcherTarget.dataset.sectionId,
        );
        link.href = newHref.toString();
      });
      delegate(this, "click", "a", this.onLinkClicked.bind(this));
      window.addEventListener("popstate", (event) => {
        this.handlePopState(event);
      });
    }

    handlePopState(event) {
      const page = event.state && event.state.page ? event.state.page : "1";

      const target = this.querySelector(`a[data-page="${page}"]`);

      if (target) {
        this.onLinkClicked(new Event("click"), target, true);
      }
    }

    onLinkClicked(event, target, isPopState = false) {
      event.preventDefault();

      const page = target.getAttribute("data-page");
      const searchParams = new URLSearchParams(window.location.search);
      target.style.position =
        getComputedStyle(target).position === "absolute" ? "" : "relative";
      target.innerHTML += window.icons.spinner;

      if (page === "1") {
        searchParams.delete("page");
      } else {
        searchParams.set("page", page);
      }

      const newUrl = `${window.location.pathname}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;

      // if isPopState is false and the section fetcher url is the same with our current url, push a new state
      // this is to prevent pushing a new url state if we are on homepage etc.
      const targetPath = getPathWithoutQuery(
        this.sectionFetcherTarget.dataset.url,
      );
      const currentPath = getPathWithoutQuery(window.location.href);
      if (!isPopState && targetPath === currentPath) {
        window.history.pushState({ page: page }, "", newUrl);
      }

      triggerEvent(this, "pagination:page-changed", {
        searchParams: searchParams.toString(),
        sectionFetcherTarget: this.sectionFetcherTarget.id,
      });

      this.sectionFetcherTarget.dataset.skeletonItems =
        target.dataset.nextItems;
      this.sectionFetcherTarget.dataset.url = `${targetPath}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;
    }

    // updateFeed(target) {
    //   const feedFetcher = document.createElement("feed-fetcher");
    //   feedFetcher.dataset.url = target.href;
    //   const parent =
    //     this.closest("feed-fetcher") || this.closest(".js-feed-block");
    //   feedFetcher.style.height = parent.clientHeight + "px";
    //   feedFetcher.style.setProperty("--next-items", target.dataset.nextItems);
    //   feedFetcher.style.setProperty(
    //     "--product-card-height",
    //     parent.querySelector("product-card").clientHeight
    //   );
    //   feedFetcher.style.opacity = 0;

    //   parent.scrollIntoView({ behavior: "smooth" });

    //   parent.animate([{ opacity: 1 }, { opacity: 0 }], {
    //     duration: 150,
    //     easing: "ease-in-out",
    //     fill: "forwards",
    //   });

    //   parent.after(feedFetcher);
    //   parent.remove();

    //   feedFetcher.animate([{ opacity: 0 }, { opacity: 1 }], {
    //     duration: 150,
    //     easing: "ease-in-out",
    //     fill: "forwards",
    //   });
    // }
  }

  window.customElements.define("pagination-element", PaginationElement);
}
// Convert the bg color to rgba format with specific opacity
function setOpacity(color, opacity) {
  // If it's a named color like 'white'
  if (!color.startsWith("rgb")) {
    const tempDiv = document.createElement("div");
    tempDiv.style.color = color;
    document.body.appendChild(tempDiv);
    color = getComputedStyle(tempDiv).color;
    tempDiv.remove();
  }

  // Extract rgb values
  const [r, g, b] = color.match(/\d+/g).map(Number);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
class GradientFinish extends HTMLElement {
  connectedCallback() {
    // reduce opacity when scroll of parent reaches end, parent could be vertical or horizontal scroll
    this.slider = document.querySelector(
      `[data-slider="${this.dataset.sliderTarget}"]`,
    );
    // find parent that has a class starting with bg-
    if (!this.slider) {
      this.remove();
      return;
    }

    // initial adjustment
    this.adjustOpacity();
    this.adjustColor();

    // adjust opacity on scroll
    this.slider.addEventListener(
      "scroll",
      debounce(this.adjustOpacity.bind(this), 100),
    );

    // adjust opacity on resize
    window.addEventListener(
      "resize",
      debounce(this.adjustOpacity.bind(this), 100),
    );
    // adjust opacity on resize
    window.addEventListener(
      "resize",
      debounce(this.adjustColor.bind(this), 400),
    );
    // adjust opacity on slider resize
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === this.slider) {
          this.adjustOpacity();
        }
      }
    });
    resizeObserver.observe(this.slider);
  }

  adjustColor() {
    let bgParentWithStyle = this.parentElement.closest("[class*='bg-']");
    if (
      bgParentWithStyle &&
      getComputedStyle(bgParentWithStyle).backgroundColor === "rgba(0, 0, 0, 0)"
    ) {
      bgParentWithStyle =
        bgParentWithStyle.parentElement.closest("[class*='bg-']");
    }
    let bg = bgParentWithStyle
      ? getComputedStyle(bgParentWithStyle).backgroundColor
      : "white";
    this.style.setProperty("--from-bg", setOpacity(bg, 0.0));
    this.style.setProperty("--to-bg", setOpacity(bg, 1));
  }

  adjustOpacity() {
    const isVertical = this.slider.scrollHeight > this.slider.clientHeight;
    const isHorizontal = this.slider.scrollWidth > this.slider.clientWidth;

    let ratio = 1;

    if (isVertical) {
      const scrollEnd = this.slider.scrollHeight - this.slider.clientHeight;
      ratio = scrollEnd > 0 ? this.slider.scrollTop / scrollEnd : 1;
    } else if (isHorizontal) {
      const scrollEnd = this.slider.scrollWidth - this.slider.clientWidth;
      ratio = scrollEnd > 0 ? this.slider.scrollLeft / scrollEnd : 1;
    }

    this.style.opacity = 1 - ratio;
  }
}
customElements.define("gradient-finish", GradientFinish);

class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary");
    this.content = el.querySelector("summary + *");
    this.subAccordions = el.querySelectorAll("details[type='accordion']");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));
    if (this.el.dataset?.accordionSyncGroup) {
      this.syncGroup = document.querySelectorAll(
        `details[type="accordion"][data-accordion-sync-group="${this.el.dataset.accordionSyncGroup}"]`,
      );
    }
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink(duration) {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: duration || 200,
        easing: "ease-out",
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);

    this.subAccordions.forEach((accordion) => {
      // shrink accordion
      const subAccordion = new Accordion(accordion);
      subAccordion.el.open && subAccordion.shrink();
    });
  }

  open() {
    if (this.syncGroup) {
      this.syncGroup.forEach((el) => {
        if (
          el !== this.el &&
          el.parentElement.closest('details[type="accordion"]') !== this.el &&
          ![...el.querySelectorAll('details[type="accordion"]')].some(
            (item) => item == this.el,
          )
        ) {
          // const subAccordion = new Accordion(el);
          // subAccordion.el.open && subAccordion.shrink(0)
          el.open && el.querySelector("summary").click();
        }
      });
    }
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content?.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: "ease-out",
      },
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}

class ProductCard extends HTMLElement {
  connectedCallback() {
    let image = this.querySelector("img.js-lazyloadBlur");
    let placeholder = this.querySelector(".js-lazyloadBlurPlaceholder");
    if (!placeholder) return;
    if (image.complete) {
      placeholder.style.opacity = 0;
      setTimeout(() => {
        placeholder.remove();
      }, 100);
      return;
    }
    image.addEventListener("load", () => {
      placeholder.style.opacity = 0;
      setTimeout(() => {
        placeholder.remove();
      }, 100);
    });
  }
}
customElements.define("product-card", ProductCard);

const tabNotification = () => {
  if (!window.tabNotification?.isEnabled) return;

  const pageTitle = document.title;
  const messages = window.tabNotification.text
    ?.split(";")
    .map((msg) => msg.trim())
    .filter((msg) => msg); // removes empty messages
  const duration = window.tabNotification.duration * 1000;

  if (!messages?.length) return; // if no valid messages, don't proceed

  let interval;
  let i = 0;

  document.addEventListener("visibilitychange", (e) => {
    if (!document.hidden) {
      document.title = pageTitle;
      clearInterval(interval);
      return;
    }

    interval = setInterval(() => {
      // Even indices show message, odd indices show page title
      document.title =
        i % 2 === 0 ? messages[Math.floor(i / 2) % messages.length] : pageTitle;

      i = (i + 1) % (messages.length * 2); // multiply by 2 to account for page title intervals
    }, duration);
  });
};
if (!customElements.get("scroll-top")) {
  customElements.define(
    "scroll-top",
    class extends HTMLElement {
      connectedCallback() {
        window.addEventListener("scroll", this.toggle.bind(this));
      }
      disconnectedCallback() {
        window.removeEventListener("scroll", this.toggle.bind(this));
      }
      toggle() {
        this.dataset.fadeIn = window.scrollY > 200 ? true : false;
      }
    },
  );
}
["DOMContentLoaded", "shopify:section:load"].forEach((event) => {
  document.addEventListener(event, () => {
    const firstSection = document.querySelector(
      "#MainContent .shopify-section:not(.shopify-section-group-header-group)",
    );
    const firstSectionMarginTop = parseInt(
      window.getComputedStyle(firstSection).marginTop,
    );
    document.body.style.setProperty(
      "--first-section-margin-top",
      `${firstSectionMarginTop}px`,
    );

    document.querySelectorAll("img.js-lazyloadBlur").forEach((image) => {
      let placeholder = image.nextElementSibling;
      if (!placeholder) return;
      if (image.complete) {
        placeholder.style.opacity = 0;
        setTimeout(() => {
          placeholder.remove();
        }, 400);
        return;
      }
      image.addEventListener("load", () => {
        placeholder.style.opacity = 0;
        setTimeout(() => {
          placeholder.remove();
        }, 400);
      });
    });
  });
});

function waitForScrollToEnd() {
  return new Promise((resolve) => {
    let scrollTimeout;
    let isScrolling = false;

    function handleScroll() {
      isScrolling = true;
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        resolve();
      }, 150); // Adjust this value to change the "scroll end" detection sensitivity
    }

    if (!isScrolling) {
      resolve();
    } else {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }
  });
}
function centerInScrollable(item) {
  const scrollableParent = getFirstScrollableParent(item);
  if (!scrollableParent) return;

  const parentRect =
    scrollableParent === window
      ? {
          width: window.innerWidth,
          height: window.innerHeight,
          left: 0,
          top: 0,
        }
      : scrollableParent.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();

  const isHorizontallyScrollable =
    scrollableParent === window
      ? document.documentElement.scrollWidth > window.innerWidth
      : scrollableParent.scrollWidth > scrollableParent.clientWidth;
  const isVerticallyScrollable =
    scrollableParent === window
      ? document.documentElement.scrollHeight > window.innerHeight
      : scrollableParent.scrollHeight > scrollableParent.clientHeight;

  let scrollLeft =
    scrollableParent === window
      ? window.pageXOffset
      : scrollableParent.scrollLeft;
  let scrollTop =
    scrollableParent === window
      ? window.pageYOffset
      : scrollableParent.scrollTop;

  if (isHorizontallyScrollable) {
    const wrapperWidth = parentRect.width;
    const itemWidth = itemRect.width;
    const itemOffsetLeft =
      itemRect.left -
      parentRect.left +
      (scrollableParent === window
        ? window.pageXOffset
        : scrollableParent.scrollLeft);
    const itemCenter = itemOffsetLeft + itemWidth / 2;
    scrollLeft = itemCenter - wrapperWidth / 2;
  }

  if (isVerticallyScrollable) {
    const wrapperHeight = parentRect.height;
    const itemHeight = itemRect.height;
    const itemOffsetTop =
      itemRect.top -
      parentRect.top +
      (scrollableParent === window
        ? window.pageYOffset
        : scrollableParent.scrollTop);
    const itemMiddle = itemOffsetTop + itemHeight / 2;
    scrollTop = itemMiddle - wrapperHeight / 2;
  }

  if (scrollableParent === window) {
    window.scrollTo({
      behavior: "smooth",
      left: scrollLeft,
      top: scrollTop,
    });
  } else {
    scrollableParent.scrollTo({
      behavior: "smooth",
      left: scrollLeft,
      top: scrollTop,
    });
  }
}

function getFirstScrollableParent(element) {
  if (!element) {
    return null;
  }

  // Start with the parent element
  let parent = element.parentElement;
  let count = 0;

  while (parent) {
    // Check if the parent is the body or html element
    if (parent === document.body || parent === document.documentElement) {
      return window;
    }

    // Get computed style
    const style = window.getComputedStyle(parent);
    const overflowX = style.getPropertyValue("overflow-x");
    const overflowY = style.getPropertyValue("overflow-y");

    // Check if the element is scrollable
    if (
      overflowX === "auto" ||
      overflowX === "scroll" ||
      overflowY === "auto" ||
      overflowY === "scroll"
    ) {
      return parent;
    }

    // Move up to the next parent
    parent = parent.parentElement;
  }

  return window;
}

let isScrolling = false;
let isAnchorLinkScroll = false;
let scrollTimeout;

// Function to update scroll state
function updateScrollState() {
  isScrolling = true;
  clearTimeout(scrollTimeout);

  scrollTimeout = setTimeout(() => {
    isScrolling = false;
    isAnchorLinkScroll = false;
  }, 100); // Adjust this value to change how quickly scrolling is considered "stopped"
}

// Add scroll event listener
window.addEventListener("scroll", updateScrollState);

// Function to handle anchor link clicks
function handleAnchorClick(event) {
  const href = event.currentTarget.getAttribute("href");
  if (href.startsWith("#")) {
    isAnchorLinkScroll = true;
    // Prevent default to handle the scroll ourselves
    event.preventDefault();
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }
}

// Add click event listeners to all anchor links
function reloadGlobalEventListeners() {
  tabNotification();

  // first remove
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.removeEventListener("click", handleAnchorClick);
  });
  // then add
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", handleAnchorClick);
  });
}
reloadGlobalEventListeners();

document.addEventListener("shopify:section:load", reloadGlobalEventListeners);
document.addEventListener("shopify:section:unload", reloadGlobalEventListeners);
document.addEventListener("dom:manipulated", reloadGlobalEventListeners);
function mirrorFixedElement(element) {
  // Get the computed style of the element
  const style = window.getComputedStyle(element);

  // Get the current right value
  const rightValue = style.right;

  // Get the element's width
  const elementWidth = element.offsetWidth;

  // Get the viewport width
  const viewportWidth = document.documentElement.clientWidth;

  // Calculate the distance from the right edge of the viewport
  const distanceFromRight = parseFloat(rightValue);

  // Calculate the new left position
  const newLeftPosition = distanceFromRight;

  // Apply the new positioning
  element.style.right = "auto"; // Remove right positioning
  element.style.left = `${newLeftPosition}px`;

  // Ensure the element doesn't overflow on the left side
  const rect = element.getBoundingClientRect();
  if (rect.left < 0) {
    element.style.left = "0px";
  }
}
function getPathWithoutQuery(url) {
  return new URL(url, window.location.origin).pathname;
}
function replaceNodeWithChildren(nodeToReplace, nodeWithChildren) {
  const parent = nodeToReplace.parentNode;
  const fragment = document.createDocumentFragment();

  while (nodeWithChildren.firstChild) {
    fragment.appendChild(nodeWithChildren.firstChild);
  }

  parent.replaceChild(fragment, nodeToReplace);
}
function replaceNodeWithNodeList(nodeToReplace, nodeList) {
  if (!(nodeList instanceof NodeList) && !Array.isArray(nodeList)) {
    throw new Error("Second argument must be a NodeList or an array of nodes");
  }

  const parent = nodeToReplace.parentNode;
  if (!parent) {
    throw new Error("Cannot replace a node that is not in the DOM");
  }

  const fragment = document.createDocumentFragment();

  // If it's an array, we need to iterate differently
  if (Array.isArray(nodeList)) {
    nodeList.forEach((node) => fragment.appendChild(node));
  } else {
    // NodeList is array-like but not an array, so we use this method
    fragment.append(...nodeList);
  }

  parent.replaceChild(fragment, nodeToReplace);
}
async function getActualHeight(el) {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const height = el.getBoundingClientRect().height;
        resolve(height);
      });
    });
  });
}
/**
 * Converts an HTML string to a DOM node.
 *
 * @param {string} htmlString - The HTML string to convert.
 * @returns {Node} The resulting DOM node.
 * @throws {Error} If the HTML string is invalid or empty.
 */
function htmlToNode(htmlString) {
  // Trim the input string to remove any leading/trailing whitespace
  htmlString = htmlString.trim();

  // Check if the input is empty
  if (!htmlString) {
    throw new Error("Input HTML string is empty");
  }

  // Create a temporary container
  const template = document.createElement("template");

  // Set the innerHTML of the template to our HTML string
  template.innerHTML = htmlString;

  // Check if the parsing was successful
  if (template.content.childNodes.length === 0) {
    throw new Error("Failed to parse HTML string");
  }

  // If there's only one child node, return it directly
  if (template.content.childNodes.length === 1) {
    return template.content.firstChild;
  }

  // If there are multiple child nodes, wrap them in a document fragment
  const fragment = document.createDocumentFragment();
  fragment.append(...template.content.childNodes);
  return fragment;
}
function toggleVisibility(
  hideElement,
  showElement,
  fadeDuration,
  visibleDuration,
) {
  hideElement.style.opacity = 0;
  setTimeout(() => {
    hideElement.classList.add("hidden");
    showElement.classList.remove("hidden");
    showElement.style.opacity = 1;
  }, fadeDuration * 1000);

  setTimeout(() => {
    showElement.style.opacity = 0;
    setTimeout(() => {
      showElement.classList.add("hidden");
      hideElement.classList.remove("hidden");
      hideElement.style.opacity = 1;
    }, fadeDuration * 1000);
  }, visibleDuration * 1000);
}

function toggleButtonState(button, state) {
  switch (state) {
    case "loading":
      if (button.dataset.state == "loading") return;
      button.setAttribute("aria-disabled", true);
      button.dataset.state = "loading";
      break;

    case "error":
      button.dataset.state = "error";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;

    case "success":
      button.dataset.state = "success";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;
  }
}

function updateLabels() {
  const labels = document.querySelectorAll("drawer accordion-content label");
  labels.forEach((label) => {
    const attr = "drawer-" + label.getAttribute("for");
    const input = label.querySelector("input");
    if (input) input.setAttribute("id", attr);
    label.setAttribute("for", attr);
    label.control = input;
  });
}

if (!customElements.get("facet-remove")) {
  customElements.define(
    "facet-remove",
    class FacetRemove extends HTMLElement {
      connectedCallback() {
        this.animate({ opacity: [0, 1] }, { duration: 200, fill: "forwards" });
        this.querySelector("a").addEventListener(
          "click",
          this.onClick.bind(this),
        );
      }
      onClick(event) {
        this.animate(
          { opacity: [1, 0.5] },
          { duration: 200, fill: "forwards" },
        );
        const filters = document.querySelector("collection-filters");
        if (!filters) return;
        filters.onActiveFilterClick(event);
      }
    },
  );
}
document.querySelectorAll('details[type="accordion"]').forEach((el) => {
  new Accordion(el);
});

if (!customElements.get("drawer-element")) {
  customElements.define(
    "drawer-element",
    class DrawerElement extends HTMLElement {
      constructor() {
        super();
        this.drawer = this.querySelector("drawer");
        this.overlay = this.querySelector(".js-overlay");
        this.keepHeader = false;
        this.animationDuration =
          parseInt(this.dataset.animationDuration) || 700;

        this.initializeAccordions();
        this.bindEvents();
      }

      // Initialize accordions
      initializeAccordions() {
        this.querySelectorAll('summary[type="accordion"]').forEach(
          (accordion) => {
            const content = accordion.nextElementSibling;
            content.style.height = "0px";
            content.style.overflow = "hidden";
          },
        );
      }

      // Bind all event listeners
      bindEvents() {
        this.triggers = document.querySelectorAll(
          `drawer-trigger[data-target="${this.id}"]`,
        );
        this.innerDrawerTitles = document.querySelectorAll(
          ".selected-inner-drawer",
        );

        this.triggers.forEach((trigger) =>
          trigger.addEventListener("click", () => this.toggleDrawer(trigger)),
        );

        // Add overlay click listener
        if (this.overlay) {
          this.overlay.addEventListener("click", () => this.closeDrawer());
        }

        // Add event listeners for keyup and focusout
        document.addEventListener("keyup", this.onKeyUp.bind(this));
        // this.addEventListener("focusout", this.onFocusOut.bind(this));
      }

      // Toggle drawer open/close
      toggleDrawer(trigger) {
        if (this.dataset.open === "true") {
          this.closeDrawer();
        } else {
          if (trigger.innerText) {
            this.innerDrawerTitles.forEach((title) => {
              title.innerText = trigger.innerText;
            });
          }
          this.openDrawer();
        }
      }

      // Handle keyup events
      onKeyUp(event) {
        if (
          event.code.toUpperCase() === "ESCAPE" &&
          this.dataset.open === "true"
        ) {
          this.closeDrawer();
        }
      }

      // Handle focus out events
      onFocusOut(event) {
        if (this.contains(event.relatedTarget)) return;
        setTimeout(() => {
          if (this.dataset.open === "true") this.closeDrawer();
        }, 0);
      }

      // Open the drawer
      openDrawer() {
        if (this.dataset.open === "true") return;

        this.handleScrollLock(true);
        this.dataset.open = "true";
        this.classList.remove("hidden");
        this.handleOverflowClasses("hidden");
        this.whenDrawerIsOpening();
        this.handleHeaderStickiness(false);
        trapFocus(this.drawer);

        this.openDrawerAnimation()
          .then(() => this.handleOverflowClasses("hidden"))
          .then(this.afterDrawerOpened.bind(this));
      }

      // Close the drawer
      closeDrawer() {
        if (this.dataset.open !== "true") return;

        this.dataset.open = "false";
        this.resetInnerDrawerTitles();
        this.whenDrawerIsClosing();
        this.handleScrollLock(false);
        this.handleOverflowClasses("scroll");
        removeTrapFocus(window);

        this.closeDrawerAnimation().then(() => {
          setTimeout(() => {
            this.classList.add("hidden");
            this.style.pointerEvents = "";
          }, 100);
          this.afterDrawerClosed();
        });
      }

      // Handle scroll locking
      handleScrollLock(lock) {
        if (
          this.dataset.lockScroll === "false" ||
          this.parentNode.closest("drawer-component")
        )
          return;

        const body = document.body;

        if (lock) {
          lockScrollForThis(this);
          this.style.pointerEvents = "";
          body.classList.add("overflow-hidden");
          if (this.keepHeader) {
            body.style.top = "0";
          }
        } else {
          unlockScrollForThis(this);
          body.classList.remove("overflow-hidden");
          body.style.top = "";
        }
      }

      // Handle overflow classes
      handleOverflowClasses(type) {
        const target =
          this.id === "cart-drawer"
            ? this.drawer
            : this.parentNode.closest("drawer-component")?.drawer;
        if (!target) return;

        target.classList.replace(
          `overflow-y-${type === "hidden" ? "scroll" : "hidden"}`,
          `overflow-y-${type}`,
        );
        target.classList.replace(
          `lg:overflow-y-${type === "hidden" ? "scroll" : "hidden"}`,
          `lg:overflow-y-${type}`,
        );
      }

      // Handle header stickiness
      handleHeaderStickiness(sticky) {
        const header = document.querySelector("header-element");
        if (header.header?.classList.contains("sticky") && !this.keepHeader) {
          header.header.classList.toggle("sticky", sticky);
        }
      }

      // Reset inner drawer titles
      resetInnerDrawerTitles() {
        this.innerDrawerTitles.forEach((title) => {
          title.innerText = "";
        });
      }

      // Animation for opening the drawer
      async openDrawerAnimation() {
        const { drawer, overlay } = this;
        const options = this.getAnimationOptions();

        this.prepareDrawerForAnimation(drawer);

        const drawerAnimation = drawer.animate(
          [{ transform: "translateX(150%)" }, { transform: "translateX(0)" }],
          options,
        );

        const overlayAnimation = overlay?.animate(
          [{ opacity: 0 }, { opacity: 0.7 }],
          options,
        );

        await Promise.all([
          drawerAnimation.finished,
          overlayAnimation?.finished,
        ]);

        drawer.style.transform = "";
        this.animation = overlayAnimation;

        return Promise.resolve();
      }

      // Animation for closing the drawer
      async closeDrawerAnimation() {
        this.style.pointerEvents = "none";
        const { drawer, overlay } = this;
        const options = this.getAnimationOptions();

        const drawerAnimation = drawer.animate(
          [{ transform: "translateX(0%)" }, { transform: "translateX(150%)" }],
          options,
        );

        const overlayAnimation = overlay?.animate(
          [{ opacity: 0.7 }, { opacity: 0 }],
          options,
        );

        await Promise.all([
          drawerAnimation.finished,
          overlayAnimation?.finished,
        ]);

        this.restoreDrawerClasses(drawer);
        this.animation?.cancel();

        return Promise.resolve();
      }

      // Get animation options
      getAnimationOptions() {
        return {
          duration: this.animationDuration,
          easing: "cubic-bezier(0.4, 0.0, 0.2, 1)",
          fill: "forwards",
        };
      }

      // Prepare drawer for animation
      prepareDrawerForAnimation(drawer) {
        if (drawer.dataset.removeToOpen) {
          drawer.classList.remove(...drawer.dataset.removeToOpen.split(" "));
        }
        drawer.style.transform = "translateX(150%)";
      }

      // Restore drawer classes after animation
      restoreDrawerClasses(drawer) {
        if (drawer.dataset.removeToOpen) {
          drawer.classList.add(...drawer.dataset.removeToOpen.split(" "));
        }
      }

      // Lifecycle hooks (to be overridden if needed)
      afterDrawerOpened() {}
      afterDrawerClosed() {}
      whenDrawerIsOpening() {}
      whenDrawerIsClosing() {}
    },
  );
}

function getVisibleHeight(element) {
  // Get the element's bounding rectangle
  const rect = element.getBoundingClientRect();

  // Get viewport height
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate top and bottom edges relative to viewport
  const elementTop = rect.top;
  const elementBottom = rect.bottom;

  // Element is completely above or below viewport
  if (elementTop >= viewportHeight || elementBottom <= 0) {
    return 0;
  }

  // Element is partially visible
  if (elementTop < 0) {
    // Element is clipped at top
    return Math.min(elementBottom, viewportHeight);
  }

  if (elementBottom > viewportHeight) {
    // Element is clipped at bottom
    return viewportHeight - elementTop;
  }

  // Element is fully visible
  return rect.height;
}
class LoadingBar extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("beforeunload", () => {
      this.animate({ opacity: [0, 1] }, { duration: 400 });
      document.body.classList.add("unloading");
    });

    window.addEventListener("DOMContentLoaded", () => {
      this.animate({ opacity: [1, 0] }, { duration: 400 }).onfinish = () => {
        this.style.visibility = "hidden";
      };

      document.body.classList.add("loaded");
      document.dispatchEvent(new CustomEvent("page:loaded"));
    });

    window.addEventListener("pageshow", (event) => {
      // Removes unload class when returning to page via history
      if (event.persisted) {
        document.body.classList.remove("unloading");
      }
    });
  }
}
customElements.define("loading-bar", LoadingBar);
class HeaderElement extends HTMLElement {
  static observedAttributes = ["data-sticky"];

  constructor() {
    super();
    this.state = {
      lastScrollTop: 0,
      isHidden: false,
      headerHeight: 0,
      announcementHeight: 0,
      productFeedInView: false,
    };

    this.config = {
      threshold: 100,
      slideDuration: 300,
      hiddenTransform: "translateY(-160px)",
    };

    this.observers = [];
  }

  connectedCallback() {
    this.setupDOMReferences();
    if (!this.isSticky || !this.header) return;

    this.setupHeaderOffset();
    this.setupHeaderStickyOffset();
    this.updateHeaderHeight();
    this.setupEventListeners();
    this.connectObservers();
    this.setupInitialStickyState();
  }

  disconnectedCallback() {
    if (!this.isSticky) return;
    this.removeEventListeners();
    this.disconnectObservers();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-sticky") {
      this.isSticky = newValue === "true";
    }
  }

  setupDOMReferences() {
    this.header = this.closest(".header-elements");
    this.announcementBar = this.querySelector(".js-announcement-bar");
    this.productFeed = document.querySelector("product-feed");
    this.isSticky = this.dataset.sticky === "true";
  }

  setupHeaderOffset() {
    const setHeaderOffset = () => {
      const headerElements = document.querySelectorAll("header-element");
      if (!headerElements.length) return;

      const headerHeight = [...headerElements].reduce(
        (acc, el) => acc + el.offsetHeight,
        0,
      );
      document.body.style.setProperty("--header-offset", `${headerHeight}px`);
    };

    setHeaderOffset();
    window.addEventListener("resize", setHeaderOffset);
  }

  setupHeaderStickyOffset() {
    const setStickyOffset = () => {
      setTimeout(() => {
        document.body.style.setProperty(
          "--header-sticky-offset",
          `${getVisibleHeight(this)}px`,
        );
      }, 500);
    };
    setStickyOffset();
    window.addEventListener("resize", setStickyOffset);
  }

  setupInitialStickyState() {
    this.headerOffset = document.createElement("div");
    this.headerOffset.style.height = `${this.state.headerHeight}px`;
    this.headerOffset.className =
      "absolute inset-0 bg-background1 shopify-section-group-header-group";
    this.headerOffset.setAttribute("aria-hidden", "true");
    // this.header.before(this.headerOffset);

    this.header.classList.add(
      "transition-top",
      "duration-300",
      "sticky",
      "z-[1010]",
      "-top-[var(--header-offset)]",
      "bg-transparent",
    );
  }

  setupEventListeners() {
    this.handleScroll = this.handleScroll.bind(this);
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this);

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateHeaderHeight);
  }

  removeEventListeners() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateHeaderHeight);
  }

  connectObservers() {
    this.setupProductFeedInViewStateObserver();
  }

  disconnectObservers() {
    this.observers.forEach((observer) => observer.disconnect());
  }

  updateHeaderHeight() {
    this.state.headerHeight = this.header.offsetHeight;
    this.state.announcementHeight = this.announcementBar?.offsetHeight ?? 0;
    if (this.headerOffset)
      this.headerOffset.style.height = `${this.state.headerHeight}px`;
  }

  handleScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.handleHeaderVisibility(scrollPosition);
  }

  setupProductFeedInViewStateObserver() {
    if (!this.productFeed) return;

    const observer = new IntersectionObserver((entries) => {
      this.state.productFeedInView = entries[0].isIntersecting;
    });

    observer.observe(this.productFeed);
    this.observers.push(observer);
  }

  handleHeaderVisibility(scrollPosition) {
    if (this.state.productFeedInView) {
      this.hideHeader();
    } else if (scrollPosition > this.config.threshold) {
      if (scrollPosition > this.state.lastScrollTop && !this.state.isHidden) {
        this.hideHeader();
      } else if (
        scrollPosition < this.state.lastScrollTop &&
        this.state.isHidden
      ) {
        this.showHeader();
      }
    } else if (scrollPosition <= this.state.announcementHeight) {
      this.resetHeaderPosition();
    } else if (this.state.isHidden) {
      this.showHeader();
    }

    this.state.lastScrollTop = scrollPosition;
  }

  hideHeader() {
    if (this.state.isHidden) return;
    this.resetHeaderPosition();
    this.state.isHidden = true;
    this.setupHeaderStickyOffset();
  }

  isMobile() {
    const mobileBreakpoints = ["xs", "sm", "md"];
    const currentBreakpoint = getCurrentBreakpoint();
    return mobileBreakpoints.includes(currentBreakpoint);
  }

  showHeader() {
    if (!this.state.isHidden) return;
    const isMobile = this.isMobile();
    this.header.style.top = isMobile
      ? `-${this.state.announcementHeight}px`
      : `-${this.state.announcementHeight}px`;
    this.state.isHidden = false;
    this.setupHeaderStickyOffset();
  }

  resetHeaderPosition() {
    if (this.header.style.top === "") return;
    this.header.style.top = "";
  }
}

customElements.define("header-element", HeaderElement);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"],input[name="locale_code"], input[name="country_code"]',
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

// fix childMenu positions
const fixChildMenuPositions = () => {
  const childMenus = document.querySelectorAll("._headerChildMenu");
  const isRTL = document.body.style.direction === "rtl";
  const windowWidth = window.innerWidth;

  childMenus.forEach((childMenu) => {
    let isOffScreen = false;
    const childMenuRect = childMenu.getBoundingClientRect();

    // Check if the child menu itself is off-screen
    if (isRTL) {
      isOffScreen = childMenuRect.left < 0;
    } else {
      isOffScreen = childMenuRect.right > windowWidth;
    }

    // If child menu is not off-screen, check its grandchild menus
    if (!isOffScreen) {
      const grandChildMenus = childMenu.querySelectorAll(
        "._headerGrandChildMenu",
      );
      grandChildMenus.forEach((grandChildMenu) => {
        // Temporarily make the grandchild menu visible for accurate measurements
        const originalDisplay = grandChildMenu.style.display;
        grandChildMenu.style.display = "block";
        grandChildMenu.style.visibility = "hidden";

        const grandChildMenuRect = grandChildMenu.getBoundingClientRect();

        // Restore original display
        grandChildMenu.style.display = originalDisplay;
        grandChildMenu.style.visibility = "";

        if (isRTL) {
          if (grandChildMenuRect.left < 0) isOffScreen = true;
        } else {
          if (grandChildMenuRect.right > windowWidth) isOffScreen = true;
        }
      });
    }

    if (isOffScreen) {
      childMenu.setAttribute("data-offscreen", "true");
    } else {
      childMenu.removeAttribute("data-offscreen");
    }
  });
};

window.addEventListener("resize", fixChildMenuPositions);
window.addEventListener("DOMContentLoaded", fixChildMenuPositions);

/**
 * ElectricModal - Modern modal system with single container approach
 * @class
 * @extends HTMLElement
 * @description Creates a single modal container that handles all modal interactions
 */
class ElectricModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.backdrop = null;
    this.content = null;
    this.previousFocus = null;
    this.isOpen = false;
    this.scrollPosition = 0;
    this.boundEventHandler = null;
  }

  connectedCallback() {
    // Only create one instance globally
    if (!window.electricModal) {
      window.electricModal = this;
      console.log('ElectricModal: Initializing');
      this.init();
    } else {
      console.log('ElectricModal: Already initialized');
    }
  }

  disconnectedCallback() {
    if (window.electricModal === this) {
      window.electricModal = null;
      this.cleanup();
    }
  }

  init() {
    this.createModalContainer();
    this.setupTriggers();
    this.setupKeyboardListeners();
  }

  cleanup() {
    // Remove event listeners
    if (this.boundEventHandler) {
      document.removeEventListener('click', this.boundEventHandler);
    }
    document.removeEventListener('keydown', this.handleKeydown);

    // Remove modal container
    if (this.modal) {
      this.modal.remove();
    }
  }

  createModalContainer() {
    // Create modal HTML structure
    const modalHTML = `
      <div
        id="electric-modal-container"
        class="fixed inset-0 hidden z-[1001]"
        role="dialog"
        aria-modal="true"
      >
        <!-- Backdrop -->
        <div
          class="electric-modal-backdrop fade-in fixed inset-0 bg-black/50" style="background-color: rgba(0,0,0,0.5)"
          data-modal-close
        ></div>

        <!-- Modal container -->
        <div class="fixed overflow-y-auto p-4 sm:p-6 left-1/2 -translate-y-1/2 -translate-x-1/2 top-1/2">
          <div class="flex min-h-full items-center justify-center">
            <!-- Modal content -->
            <div
              class="electric-modal-content slide-up-sm relative bg-white shadow-xl w-fit pointer-events-auto h-fit"
              role="document"
            >
              <!-- Content will be inserted here -->
            </div>
          </div>
        </div>
      </div>
    `;

    // Add to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // Cache elements
    this.modal = document.getElementById('electric-modal-container');
    this.backdrop = this.modal.querySelector('.electric-modal-backdrop');
    this.content = this.modal.querySelector('.electric-modal-content');

    // Setup backdrop click handler
    this.backdrop.addEventListener('click', () => this.close('backdrop'));
  }

  setupTriggers() {
    // Use event delegation for modal triggers
    this.boundEventHandler = (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const modalId = trigger.dataset.modalTrigger;
      const data = this.collectTriggerData(trigger);

      console.log('ElectricModal: Opening modal', modalId, data);
      this.open(modalId, data);
    };

    document.addEventListener('click', this.boundEventHandler);
    console.log('ElectricModal: Event listener attached');
  }

  setupKeyboardListeners() {
    this.handleKeydown = (e) => {
      if (!this.isOpen) return;

      if (e.key === 'Escape') {
        this.close('escape');
      }

      // Focus trap
      if (e.key === 'Tab') {
        this.handleTabKey(e);
      }
    };

    document.addEventListener('keydown', this.handleKeydown);
  }

  collectTriggerData(trigger) {
    const data = {};

    // Collect all data-modal-* attributes
    Array.from(trigger.attributes).forEach(attr => {
      if (attr.name.startsWith('data-modal-') && attr.name !== 'data-modal-trigger') {
        const key = attr.name.replace('data-modal-', '');
        data[key] = attr.value;
      }
    });

    return data;
  }

  async open(modalId, data = {}) {
    console.log('ElectricModal.open called with:', modalId, data);
    if (this.isOpen) {
      console.log('ElectricModal: Already open, returning');
      return;
    }

    try {
      // Store current focus
      this.previousFocus = document.activeElement;

      // Use LayerManager to handle z-index with parent tracking
      const layerId = `modal-${modalId}`;
      if (window.layerManager) {
        const parentContext = window.layerManager.getCurrentContext();
        window.layerManager.push(layerId, 'modal', this.modal, parentContext);
        this.modal.dataset.layerId = layerId;
        this.currentModalId = layerId;

        // Mark as animating (for fade in)
        window.layerManager.startAnimating(layerId);
      }

      // Load content
      await this.loadContent(modalId, data);

      // Lock body scroll
      this.lockBodyScroll();

      // Show modal with animation
      this.modal.classList.remove('hidden');

      // Wait a frame for the display change to take effect
      await new Promise(resolve => requestAnimationFrame(resolve));

      // Add animation classes if they exist
      this.modal.classList.add('modal-open');

      // Set state
      this.isOpen = true;

      // Focus management
      this.trapFocus();

      // Animation complete
      if (window.layerManager && layerId) {
        // Small delay to ensure animation has started
        setTimeout(() => {
          window.layerManager.stopAnimating(layerId);
        }, 300);
      }

      // Dispatch event
      this.dispatchEvent('modal:open', { modalId, data });

    } catch (error) {
      console.error('Error opening modal:', error);
      this.close();
    }
  }

  async loadContent(modalId, data) {
    // Show loading state
    this.content.innerHTML = `
      <div class="p-8 text-center">
        <div class="inline-block w-6 h-6 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin"></div>
        <p class="mt-2 text-sm text-gray-600">Loading...</p>
      </div>
    `;

    // Check if there's a template element for this modal
    const template = document.querySelector(`template[data-modal-content="${modalId}"]`);

    if (template) {
      // Use template content
      this.content.innerHTML = template.innerHTML;

      // Replace any template variables with data
      this.replaceTemplateVariables(data);

      // Check for section-fetcher and load content if present
      const sectionFetcher = this.content.querySelector('section-fetcher');
      if (sectionFetcher) {
        await sectionFetcher.checkAndFetch?.();
      }

    } else {
      // Try to find existing modal content
      const existingModal = document.querySelector(`[data-modal-id="${modalId}"]`);

      if (existingModal) {
        this.content.innerHTML = existingModal.innerHTML;
      } else {
        // Fallback content
        this.content.innerHTML = `
          <div class="p-6">
            <h3 class="text-lg font-medium mb-4">Modal</h3>
            <p class="text-gray-600 mb-6">Modal content for "${modalId}"</p>
            <div class="flex justify-end">
              <button
                type="button"
                class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                data-modal-close
              >
                Close
              </button>
            </div>
          </div>
        `;
      }
    }

    // Setup close buttons
    this.setupCloseButtons();
  }

  replaceTemplateVariables(data) {
    Object.keys(data).forEach(key => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      this.content.innerHTML = this.content.innerHTML.replace(regex, data[key] || '');
    });
  }

  setupCloseButtons() {
    const closeButtons = this.content.querySelectorAll('[data-modal-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close('button'));
    });
  }

  close(reason = 'programmatic') {
    if (!this.isOpen) return;

    try {
      // Dispatch closing event (cancelable)
      const closingEvent = this.dispatchEvent('modal:closing', { reason });
      if (closingEvent.defaultPrevented) return;

      const layerId = this.modal.dataset.layerId;

      // Mark as animating for close animation
      if (window.layerManager && layerId) {
        window.layerManager.startAnimating(layerId);
      }

      // Remove animation classes
      this.modal.classList.remove('modal-open');

      // Wait for fade out animation (if any)
      const animationDuration = 300; // milliseconds
      setTimeout(() => {
        // Hide modal
        this.modal.classList.add('hidden');

        // Animation complete - now remove from LayerManager
        if (window.layerManager && layerId) {
          window.layerManager.stopAnimating(layerId);
          window.layerManager.remove(layerId);
          delete this.modal.dataset.layerId;
        }

        // Restore body scroll
        this.unlockBodyScroll();

        // Restore focus
        if (this.previousFocus && this.previousFocus.focus) {
          // Use setTimeout to avoid scroll issues
          setTimeout(() => {
            if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
              this.previousFocus.focus({ preventScroll: true });
            }
          }, 0);
        }

        // Clear content
        this.content.innerHTML = '';

        // Set state
        this.isOpen = false;
        this.currentModalId = null;

        // Dispatch closed event
        this.dispatchEvent('modal:closed', { reason });
      }, animationDuration);

    } catch (error) {
      console.error('Error closing modal:', error);
      // Force cleanup on error
      this.modal.classList.add('hidden');
      this.isOpen = false;
    }
  }

  lockBodyScroll() {
    if (typeof lockScrollForThis === 'function') {
      lockScrollForThis(this.modal);
    } else {
      // Fallback if helpers not available
      this.scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    }
  }

  unlockBodyScroll() {
    if (typeof unlockScrollForThis === 'function') {
      unlockScrollForThis(this.modal);
    } else {
      // Fallback if helpers not available
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (this.scrollPosition) {
        window.scrollTo(0, this.scrollPosition);
      }
    }
  }

  trapFocus() {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  handleTabKey(e) {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  dispatchEvent(name, detail = {}) {
    const event = new CustomEvent(name, {
      detail,
      bubbles: true,
      cancelable: name === 'modal:closing'
    });

    document.dispatchEvent(event);
    return event;
  }

  // Public API methods
  static open(modalId, data = {}) {
    if (window.electricModal) {
      return window.electricModal.open(modalId, data);
    }
  }

  static close(reason = 'programmatic') {
    if (window.electricModal) {
      return window.electricModal.close(reason);
    }
  }

  static isOpen() {
    return window.electricModal ? window.electricModal.isOpen : false;
  }
}
customElements.define("electric-modal", ElectricModal);